window.UrgencyTimer ?= {}

UrgencyTimer.Helpers = require '../../common/helpers'

UrgencyTimer.Model = Backbone.Model.extend
  timeLeft: ->
    millisLeft = UrgencyTimer.Helpers.millisRemaining @get('endAt')
    UrgencyTimer.Helpers.timeRemaining millisLeft


module.exports = UrgencyTimer.Model
